module.exports = "/_next/static/images/9c891f92bbe47fbbd84e8061ab7b0d20-check.svg";